import s from './FormError.module.scss';

export default function FormError({ children }) {
  return <div className={s.wrapper}>{children}</div>;
}
